import React, { useState } from "react";
import { Drawer, Card } from "antd";
import { SimpleButton } from "@terrestris/react-geo";

function Legend(props) {
  const symbologyImgGeneral = `./data/legend/${props.imgLegendGeneral}.jpg`;
  const symbologyImg = `./data/legend/${props.imgLegend}.jpg`;
  const authorsList = props.authors;


  const [visible, setVisible] = useState(false);
  const toggleDrawer = () => {
    setVisible(!visible);
  };

  return (

    <div>
      <SimpleButton
        style={{ position: "fixed", top: props.top, left: "30px" }}
        onClick={toggleDrawer}
        shape="circle"
        // icon="info"
        iconName="info"
        tooltip="Ver leyenda"
        tooltipPlacement="right"
        size="medium"

      />
      <Drawer
        title="Leyenda"
        placement="right"
        onClose={toggleDrawer}
        visible={visible}
        mask={false}
        style={{ position: "absolute" }}
        width={window.innerWidth > 400 ? 400 : 300}
      >
        <Card size="small" title="Título">
          <p><b>{props.title}</b></p>
        </Card>
        <div style={{ paddingTop: "15px" }}>
          <Card size="small" title="Leyenda" >
            <img width="100%" alt="Symbology 1" src={symbologyImgGeneral} />
          </Card>
        </div>
        <div style={{ paddingTop: "15px" }}>
          <Card size="small">
            <img width="100%" alt="Symbology 2" src={symbologyImg} />
          </Card>
        </div>
        <div style={{ paddingTop: "15px" }}>
          <Card size="small" title="Redactores">
            <p />
            {authorsList.map((item) => (
              <p key={item} style={{ "line-height": "25px" }}>{item}</p>
            ))}
          </Card>

        </div>
        {/* <div style={{ paddingTop: "35px" }}>
          <img width="100%" alt="Ayto" src="./img/ayto.jpeg" />
        </div> */}
      </Drawer>
    </div>
  );
}

export default Legend;
